const AdTypes = {
    Leaderboard: 'leaderboard',
    Bigbox: 'bigbox',
};

export default AdTypes;
